function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from "react";

var TooltipButton = function TooltipButton(_ref) {
  var href = _ref.href,
      className = _ref.className,
      tooltip = _ref.tooltip,
      style = _ref.style,
      children = _ref.children,
      target = _ref.target;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  var _React$useState3 = React.useState({
    x: 0,
    y: 0
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      coords = _React$useState4[0],
      setCoords = _React$useState4[1];

  var ref = React.useRef(null);

  var showTooltip = function showTooltip(e) {
    var _ref$current;

    var rect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
    setCoords({
      x: rect ? rect.left + rect.width / 2 : "clientX" in e ? e.clientX : 0,
      y: rect ? rect.top : "clientY" in e ? e.clientY : 0
    });
    setShow(true);
  };

  return /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      display: "inline-block"
    },
    onMouseEnter: showTooltip,
    onMouseLeave: function onMouseLeave() {
      return setShow(false);
    },
    onFocus: showTooltip,
    onBlur: function onBlur() {
      return setShow(false);
    },
    ref: ref
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    className: className,
    style: style,
    tabIndex: 0,
    target: target,
    "aria-label": tooltip
  }, children), show && /*#__PURE__*/React.createElement("span", {
    style: {
      position: "fixed",
      left: coords.x,
      top: coords.y - 36,
      background: "#333",
      color: "#fff",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "11px",
      whiteSpace: "nowrap",
      zIndex: 9999,
      pointerEvents: "none",
      transform: "translateX(-50%)"
    },
    role: "tooltip"
  }, tooltip));
};

export default TooltipButton;